

<template>
  <div class="header">
    <center></center>
    <br><br>
            <div class="body" ref="content" id="content" style="padding: 30px;">
             
                <center><h2 class="claim" style="margin-bottom: 40px">Die Testauswertung hat folgende berufliche Interessen ermittelt:</h2></center>
                <ul id="list" class="list">
                    <li><div class="list-text">1. <a :href="link0" target="_blank"><font style="vertical-align: inherit;">{{text0}}</font></a></div><div class="list-num"><font style="vertical-align: inherit;">{{ptn}}</font></div></li>
                    <li><div class="list-text">2. <a :href="link1" target="_blank"><font style="vertical-align: inherit;">{{text1}}</font></a></div><div class="list-num"><font style="vertical-align: inherit;">{{pph}}</font></div></li>
                    <li><div class="list-text">3. <a :href="link2" target="_blank"><font style="vertical-align: inherit;">{{text2}}</font></a></div> <div class="list-num"><font style="vertical-align: inherit;">{{pks}}</font></div></li>
                    <li><div class="list-text">4. <a :href="link3" target="_blank"><font style="vertical-align: inherit;">{{text3}}</font></a></div> <div class="list-num"><font style="vertical-align: inherit;">{{pse}}</font></div></li>
                    <li><div class="list-text">5. <a :href="link4" target="_blank"><font style="vertical-align: inherit;">{{text4}}</font></a></div> <div class="list-num"><font style="vertical-align: inherit;">{{pku}}</font></div></li>
                    <li><div class="list-text">6. <a :href="link5" target="_blank"><font style="vertical-align: inherit;">{{text5}}</font></a></div> <div class="list-num"><font style="vertical-align: inherit;">{{pvo}}</font></div>
                    </li>
                </ul>
            </div>
  <h2 class="claim">Die Basis-Check Ergebnisse für die weitere Verwendung hier zum Download bereit.</h2>
    <button class="load" @click="downpdf">Download PDF</button>
  </div>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'

export default {
  components: {
    VueHtml2pdf
  },
  data() {
    return {
        showContent: true
    }
  },
  name: 'Complete',
  methods: {
    downpdf() {
      this.$store.dispatch('pdfcreate')
    },
  },
  computed: {
   
    pph() {
      return this.$store.state.pph
    },
    ptn() {
      return this.$store.state.ptn
    },
    pks() {
      return this.$store.state.pks
    },
    pse() {
      return this.$store.state.pse
    },
    pvo() {
      return this.$store.state.pvo
    },
    pku() {
      return this.$store.state.pku
    },
   
    pct0() {
      return this.$store.state.pct0
    },
    pct1() {
      return this.$store.state.pct1
    },
    pct2() {
      return this.$store.state.pct2
    },
    pct3() {
      return this.$store.state.pct3
    },
    pct4() {
      return this.$store.state.pct4
    },
    pct5() {
      return this.$store.state.pct5
    },
    text0(){
      return this.$store.state.text0
    },
    text1(){
      return this.$store.state.text1
    },
    text2(){
      return this.$store.state.text2
    },
    text3(){
      return this.$store.state.text3
    },
    text4(){
      return this.$store.state.text4
    },
    text5(){
      return this.$store.state.text5
    },
    link0(){
      return "https://dev.ausbildungsregion-os.de/berufelexikon?berufsbereich=" + this.$store.state.link0
    },
    link1(){
      return "https://dev.ausbildungsregion-os.de/berufelexikon?berufsbereich=" + this.$store.state.link1
    },
    link2(){
        return "https://dev.ausbildungsregion-os.de/berufelexikon?berufsbereich=" + this.$store.state.link2
      },
    link3(){
        return "https://dev.ausbildungsregion-os.de/berufelexikon?berufsbereich=" + this.$store.state.link3
      },
    link4(){
        return "https://dev.ausbildungsregion-os.de/berufelexikon?berufsbereich=" + this.$store.state.link4
      },
    link5(){
        return "https://dev.ausbildungsregion-os.de/berufelexikon?berufsbereich=" + this.$store.state.link5
      },
   
  },


}
</script>

<style scoped>
.header {
  margin: 0 15px 40px 15px;
  text-align: center;
  color: black;
}
.body {
    /* height: 500px; */
    /* background-image: url('../assets/pic10.jpg'); */

}
.body1 {
    height: 1000px;
    width: 80%;
    margin-left: 10%;
    /* background-image: url('../assets/pic10.jpg'); */

}
#create-pdf{
  background-image: url('/basis-check/img/pdfheader.jpg');
  background-size: 100%;
  width: 100%;
  height: 238px;
  /* margin-left: 15%; */
  margin-top: 50px;
}
.text-pdf{
  margin: 50px 0;
}

.text-pdf2{
  margin: 10px 0;
} 
.logo svg {
  margin: 0 auto 25px auto;
  display: block;
}

.title,
.claim {
  margin: 0;
}

.title {
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  font-size: 2.25rem;
}

.claim {
  font-weight: 300;
  font-size: 1.4em;
}
.load{
	font-family: 'Dosis', sans-serif;
	color: #fff;
    width: 200px;
    height: 50px;
    margin-top:50px;
    background-color: #26428D;;
     font-size: 20px;
}
.load:hover{
    background-color: grey;
}
.body p,
.body1 p {
    /* float: left; */
    /* text-align: left; */
    font-size: 1.15rem;
    /* margin-top: 20px; */
    margin-left: 0px;
}
.list-text{
    text-align: left;
    display: table-cell;
}
.list-num{
    width: 72px;
    display: table-cell;
}
.body ul.list,
.body1 ul.list {
    display: table;
    width: 100%;
    padding: 8px 0;
    margin: 0;
    list-style: none;
    font-weight: 700;
}
.body ul.list li,
.body1 ul.list li {
    display: table-row;
    height: 40px;
    font-size: 1.3em;
}
.body ul.list li>:first-child,
.body1 ul.list li>:first-child {
    padding-left: 16px;
}

a {text-decoration: none;}
</style>



// WEBPACK FOOTER //
// src/components/Complete.vue